import { connect } from 'react-redux'
import UploadPage from '../views/UploadPage'
import { 
  uploadFile, 
  // listUploadedFile, 
  downloadReport, 
  listDBFileInfo, 
  deleteUploadedFile, 
  generateReport, 
  getReportStatus, 
  getJsonWarning,
  // Import the silent versions of the actions
  // silentListUploadedFile,
  silentListDBFileInfo,
  silentGetJsonWarning 
} from '../action/userAction'

function mapStateToProps(state, ownProps) {
  let members = state.getIn(['data', 'members']);
  let uploaded_files = state.getIn(['data', 'uploaded_files']);
  let file_info = state.getIn(['data', 'file_info']);
  let general_report_status = state.getIn(['data', 'general_report_status']);
  let json_warning = state.getIn(["data", "json_warning"]);
  let pagination = state.getIn(['data', 'pagination']);
  
  return {
    members: members,
    uploaded_files: uploaded_files,
    file_info: file_info,
    general_report_status: general_report_status,
    json_warning: json_warning,
    pagination: pagination
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onUploadFile: (file) => {
    dispatch(uploadFile(file));
  },
  // For initial load, use the regular (visible loading) version
  listReports: (page = 1, pageSize = 100) => {
    dispatch(listDBFileInfo(page, pageSize));
  },
  // For background refreshes, use the silent versions
  silentListReports: (page = 1, pageSize = 100) => {
    dispatch(silentListDBFileInfo(page, pageSize));
  },
  downloadReport: (fileInfo) => {
    dispatch(downloadReport(fileInfo));
  },
  onDeleteUploadedFile: (id) => {
    dispatch(deleteUploadedFile(id));
  },
  onGenerateReport: () => {
    dispatch(generateReport());
  },
  onGetReportStatus: () => {
    dispatch(getReportStatus());
  },
  getJsonWarning: () => {
    dispatch(getJsonWarning());
  },
  silentGetJsonWarning: () => {
    dispatch(silentGetJsonWarning());
  },
})

const UploadPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadPage)

export default UploadPageContainer